<div class="flex md:flex-row flex-col gap-6 items-center justify-between mb-6">
  <h2 class="self-start">{{'personalizedJourney.title' | transloco}}</h2>
  <div class="flex flex-col gap-[0.8rem] items-end self-end">
    <progression-bar />
    @if(userRole()!="User"){
    <toggle
      [isActive]="modeDraft()"
      (toggleChange)="toggleDraftMode()"
      [text]="'components.toggle.showPendingTiles' | transloco"
    ></toggle>
    }
    <app-button
      [text]="'personalizedJourney.clarify.resetResearch' | transloco"
      [variant]="'secondary'"
      [icon]="'back'"
      [iconSize]="'1.5rem'"
      [size]="'sm'"
      (buttonClick)="redirectToJourneyResearch()"
    ></app-button>
  </div>
</div>

<div class="flex flex-col gap-6 mb-20">
  <app-journey-breadcrumb />
  <div class="p-6 bg-white rounded-xl">
    <h2 class="mb-6">{{'personalizedJourney.clarify.title' | transloco}}</h2>
    <div class="flex flex-col gap-6">
      @if(tilesLoading()){
      <loader />
      } @else { @for (tile of tilesLanguageTestToShow(); track $index) {
      <div class="p-6 bg-vinciLavender rounded-xl flex flex-col gap-6">
        <div class="flex gap-3 items-center">
          <icon [name]="'questionnaire'" [size]="'1.875rem'" />
          <h3>{{tile?.title}}</h3>
        </div>
        <p [innerHTML]="tile?.text | safeHtml"></p>

        <app-button
          [text]="'personalizedJourney.languageTest.ctaText' | transloco"
          [variant]="'secondary'"
          [icon]="'arrow-right'"
          (buttonClick)="clickOnTile(tile)"
          class="w-fit"
        />
      </div>
      } }
    </div>
  </div>
</div>

@if(isRedirectionExternal() && isModalOpen()) {
  <app-modal
    [title]="'components.modal.title' | transloco"
    [buttonText]="'components.modal.ctaButtonText' | transloco"
    [text]="effectiveTextDisclaimer() ? effectiveTextDisclaimer() : 'components.modal.textDisclaimerDefault' | transloco"
    (closeModal)="closeModal()"
    (completeModal)="goToLinkForExternalRedirection()"
    class="tile-modal"
  ></app-modal>
}